// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"03e71c3e","70":"b3b6baec","84":"3c8f2997","126":"aa0714a4","236":"173bacfd","451":"2097a634","479":"84985948","489":"8fde5508","601":"24256e3c","645":"e4c8f066","653":"4e2165bf","706":"65eda6b0","707":"1bc9372a","756":"194dc70b","771":"ed67a5ff","821":"fa9d976c"}[chunkId] + ".chunk.js";
};